var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.countInMode && _vm.ghostOffset > 0),expression:"countInMode && ghostOffset > 0"}],staticClass:"bg-blue-700 bg-opacity-40 h-6 absolute top-2 left-0 rounded-l-sm",style:({
        transform: ("translateX(" + _vm.ghostOffset + "px)"),
        width: (_vm.ghostWidth + "px")
    })}),_c('div',{staticClass:"bg-blue-700 h-6 absolute top-2 left-0 rounded-sm",style:({
        transform: ("translateX(" + _vm.offset + "px)"),
        width: (_vm.width + "px")
    }),on:{"click":function($event){return _vm.$emit('loop:clicked', _vm.id)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }